module.exports = __webpack_public_path__ + "static/chauntea-DND3_FnP-b9a8a640ef8deadaae42f88fe21f6daa.webp";